// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setDayOfYear as fn } from "../setDayOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setDayOfYear = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setDayOfYear;
